import Vue from "vue";

import RewardsGreetingDynamic from "./RewardsGreetingDynamic.vue";

export function load() {
    const selector = "rewards-greeting-dynamic";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(RewardsGreetingDynamic, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
